import {
  ChartsGrid,
  LineChart,
  lineElementClasses,
  markElementClasses,
} from "@mui/x-charts";
import * as React from "react";

const uData = [40000, 300000, 20000, 27800, 18900, 23900, 34900];
const pData = [24000, 13980, 98000, 39080, 48000, 38000, 43000];
const qData = [34000, 239800, 84000, 59080, 18000, 28000, 73000];
const rData = [44000, 33980, 58000, 69080, 48000, 189000, 46000];

const xLabels = [1, 5, 10, 15, 20, 25, 30];

export default function ProductPriceHistory() {
  return (
    <LineChart
      width={700}
      height={500}
      series={[
        { data: pData, label: "Amazon", color: "#FF9900" },
        { data: uData, label: "Flipkart", color: "#F9D823" },

        { data: qData, label: "Jiomart", color: "#0F0E96" },
        { data: rData, label: "Croma", color: "#00ACA4" },
      ]}
      xAxis={[{ scaleType: "point", data: xLabels, label: "January 2024" }]}
      // loading
      sx={{
        fontFamily: "Poppins",
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "47px",
        textAlign: "center",
        "& .MuiChartsLegend-root": {
          fontFamily: "Poppins",
        },
        [`& .${lineElementClasses.root}`]: {
          strokeWidth: 1,
        },
        [`& .${markElementClasses.root}`]: {
          display: "none",
          scale: "0",
        },
      }}
      margin={{ bottom: 150 }}
      slotProps={{
        legend: {
          direction: "row",
          position: { vertical: "bottom", horizontal: "middle" },
          itemMarkWidth: 20,
          itemMarkHeight: 20,
          markGap: 11,
          itemGap: 30,
        },
      }}
    >
      <ChartsGrid vertical horizontal />
    </LineChart>
  );
}
